// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"4184f010","787":"117f3e6a"}[chunkId] + ".chunk.js";
};